module.exports = __webpack_public_path__ + "img/Training_courses_icon_4.0d15b104.svg";